import React from 'react';
import { StyledTitleWithUIGuidelines } from './styles';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

type TProps = {
  title: string;
  color?: string;
  margin?: string;
};

export const TitleWithUIGuidelines = ({ title, margin, color }: TProps) => {
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <StyledTitleWithUIGuidelines
      isMobile={isMobile}
      margin={margin}
      color={color}
    >
      {title}
    </StyledTitleWithUIGuidelines>
  );
};
